// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/views/Material/components/Masonry/components/SpitTech/styles.scss
// module id = 1171
// module chunks = 0